module.exports = __webpack_public_path__ + "img/Patient-centred.b47ebead.png";